const renderAnimalFiltersText = (animalFilters: any) => {
  const list = [
    animalFilters.estado,
    animalFilters.pertencentes ? 'pertencente' : 'externo',
    animalFilters.sexo,
    animalFilters.raça,
    animalFilters.ano && `nascimento ${animalFilters.ano}`,
    animalFilters.safra && `safra ${animalFilters.safra}`,
    animalFilters.categoria,
    animalFilters.lote && `lote ${animalFilters.lote}`,
  ];

  let current = '';
  list.map((e: string, index: any) => {
    if (e) {
      if (index === 0) {
        current = e;
      } else {
        current = `${current}, ${e}`;
      }
    }
  });

  return current;
};

export default renderAnimalFiltersText;
